import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function ProblemSection() {
  return <>
      <Section background="white" data-id="element-54">
        <div className="text-center mb-16" data-id="element-55">
          <h2 className="text-3xl md:text-4xl text-[#2D3B2D] mb-4" data-id="element-56">
            Para quién es esto (y para quién no)
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-57">
          {/* For You */}
          <div className="bg-[#FDF8F0] p-8 rounded-2xl border border-[#E8EDE6]" data-id="element-58">
            <h3 className="text-2xl text-[#2D3B2D] mb-6 flex items-center" data-id="element-59">
              <span className="bg-[#A8B5A0] text-white rounded-full p-1 mr-3" data-id="element-60">
                <Check size={20} data-id="element-61" />
              </span>
              Esto es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-62">
              {["Tienes 2–8 deudas (tarjetas, préstamos) y sientes que 'todo está encima'", 'Pagas mínimos y te frustra que no baje', 'Evitas mirar porque te da ansiedad o vergüenza', "Has intentado 'presupuestar' y lo abandonas a los 3 días", 'Eres impulsiva cuando estás estresada y luego te culpas'].map((item, i) => <li key={i} className="flex items-start text-[#4A5D4A]" data-id="element-63">
                  <span className="mr-3 mt-1.5 h-1.5 w-1.5 bg-[#2D3B2D] rounded-full flex-shrink-0" data-id="element-64" />
                  {item}
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-white p-8 rounded-2xl border border-gray-100" data-id="element-65">
            <h3 className="text-2xl text-[#2D3B2D] mb-6 flex items-center" data-id="element-66">
              <span className="bg-gray-300 text-white rounded-full p-1 mr-3" data-id="element-67">
                <X size={20} data-id="element-68" />
              </span>
              Esto NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-69">
              {["Buscas un milagro, 'hacer dinero rápido', o promesas irreales", 'Quieres asesoría legal/financiera personalizada (esto es educativo)', 'No estás dispuesta a mirar tus números por 30 minutos (aunque te incomode)'].map((item, i) => <li key={i} className="flex items-start text-gray-600" data-id="element-70">
                  <span className="mr-3 mt-1.5 h-1.5 w-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-71" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </Section>

      <Section background="sage" className="text-center" data-id="element-72">
        <div className="max-w-3xl mx-auto" data-id="element-73">
          <h2 className="text-3xl md:text-4xl text-[#2D3B2D] mb-8" data-id="element-74">
            El problema no es que seas{' '}
            <span className="italic text-[#2D3B2D]/80" data-id="element-75">
              "mala con el dinero"
            </span>
          </h2>
          <div className="space-y-6 text-lg text-[#2D3B2D]/90 leading-relaxed" data-id="element-76">
            <p data-id="element-77">
              El problema es que estás intentando resolver algo emocionalmente
              pesado con herramientas frías.
            </p>
            <p data-id="element-78">
              Las hojas de Excel no te calman. Los "tips" de TikTok no te
              sostienen cuando estás agotada. Y la disciplina como castigo… solo
              dura hasta que el mes se pone feo.
            </p>
            <p data-id="element-79">
              Cuando estás estresada, tu cerebro quiere una cosa: alivio rápido.
              Y adivina qué da alivio rápido: no mirar… o comprar algo.
            </p>
            <div className="bg-[#FDF8F0] p-6 rounded-xl inline-block mt-4 shadow-sm" data-id="element-80">
              <p className="font-medium text-[#2D3B2D]" data-id="element-81">
                No es falta de carácter. Es falta de un sistema de decisiones
                cerradas.
              </p>
            </div>
          </div>
        </div>
      </Section>
    </>;
}